/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import { showError } from '@utils';
import { QUERY_KEYS } from 'constants/queryKeys';
import { useQuery } from 'react-query';
import { productsServices } from '@services';
import { normalizeProduct } from './utils';

export const useProductOperations = () => {
  const {
    query: { productId },
  } = useRouter();

  const productResponse = useQuery(
    [QUERY_KEYS.GET_PRODUCT_KEY, productId],
    () => productsServices?.getProductById(productId),
    { enabled: !!productId }
  );

  const product = useMemo(
    () => normalizeProduct(productResponse?.data?.data),
    [productResponse?.data?.data]
  );

  useEffect(() => {
    if (productResponse?.isError) {
      showError(productResponse?.error);
    }
  }, [productResponse?.isError]);

  const loading = productResponse.isFetching;

  return {
    loading,
    productId,
    product,
    getProduct: productResponse.refetch,
  };
};
